import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styled from 'styled-components';

export const NavigationLinksWrap = styled.ul`
  align-items: center;
  display: flex;
  justify-content: space-around;
  list-style-type: none;
  margin: 50px auto 25px;
  max-width: 800px;
  padding: 0;
`;

const Li = styled.li`
  text-align: center;

  a {
    box-sizing: border-box;
    color: ${props => props.theme.gray};
    display: block;
    font-size: 1.2rem;
    line-height: 50px;
    padding: 1rem 2rem;
    transition: background-color 0.35s;
    width: 170px;

    &:before {
      border: ${props => `solid ${props.theme.gray}`};
      border-width: 0 1px 1px 0;
      content: '';
      display: ${props => (props.prev ? 'inline-block' : 'none')};
      margin-right: 15px;
      padding: 5px;
      transform: rotate(135deg) scale(2);
      transition: transform 0.35s;
    }

    &:after {
      border: ${props => `solid ${props.theme.gray}`};
      border-width: 0 1px 1px 0;
      content: '';
      display: ${props => (props.prev ? 'none' : 'inline-block')};
      margin-left: 15px;
      padding: 5px;
      transform: rotate(-45deg) scale(2);
      transition: transform 0.35s;
    }

    &:hover,
    &:focus {
      background-color: ${props => props.theme.grayLight};

      &:before {
        transform: rotate(135deg) scale(3);
      }

      &:after {
        transform: rotate(-45deg) scale(3);
      }
    }
  }
`;

const NavigationLinks = ({ nextLink, nextCopy, prevLink, prevCopy }) => (
  <NavigationLinksWrap>
    {!!nextLink &&
      !!nextCopy && (
        <Li prev>
          <Link to={nextLink} title={`Visit ${nextCopy}`}>
            Previous
          </Link>
        </Li>
      )}
    {!!prevLink &&
      !!prevCopy && (
        <Li>
          <Link to={prevLink} title={`Visit ${prevCopy}`}>
            Next
          </Link>
        </Li>
      )}
  </NavigationLinksWrap>
);

NavigationLinks.propTypes = {
  nextLink: PropTypes.string,
  nextCopy: PropTypes.string,
  prevLink: PropTypes.string,
  prevCopy: PropTypes.string
};

export default NavigationLinks;



// WEBPACK FOOTER //
// ./src/components/NavigationLinks.js